export default "__VITE_ASSET__CormdRkn__"